import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  for: "email",
  class: "form-control-label text-uppercase"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  class: "form-control-label text-uppercase",
  for: "audioWhileLearning"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-control-label text-uppercase" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { value: null }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-control-label text-uppercase" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  class: "radio-label",
  for: "male"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  class: "radio-label",
  for: "female"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  class: "form-control-label text-uppercase",
  for: "vocabs"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "form-group text-right" }
const _hoisted_22 = {
  class: "btn btn-primary",
  type: "submit"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-control-label text-uppercase" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "form-group text-right" }
const _hoisted_31 = {
  class: "btn btn-primary",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("messages.E-mail / username")), 1),
        _withDirectives(_createElementVNode("input", {
          id: "email",
          type: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.user.email = $event)),
          disabled: "",
          class: "form-control"
        }, null, 512), [
          [_vModelText, _ctx.user.email]
        ]),
        _hoisted_4
      ])
    ], 32),
    (_ctx.user.type==='student')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.voice output")), 1),
            _withDirectives(_createElementVNode("input", {
              style: {"margin-left":"10px"},
              type: "checkbox",
              id: "audioWhileLearning",
              value: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.userSettings.audiosWhileLearning = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.userSettings.audiosWhileLearning]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("messages.superlearning music")), 1),
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              style: {"min-width":"100%"},
              class: "form-select",
              "aria-label": "Default select example",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.userSettings.superlearningId = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAudios, (audio) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: audio.id,
                  value: audio.id
                }, _toDisplayString(audio.name), 9, _hoisted_10))
              }), 128)),
              _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("messages.disabled")), 1)
            ], 512), [
              [_vModelSelect, _ctx.userSettings.superlearningId]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("messages.Voice")), 1),
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "male",
              value: "m",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.userSettings.preferredVoice = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.userSettings.preferredVoice]
            ]),
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("messages.masculine")), 1),
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "female",
              value: "f",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.userSettings.preferredVoice = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.userSettings.preferredVoice]
            ]),
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("messages.Feminine")), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("messages.Number of vocabulary per learning unit")), 1),
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "vocabs",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.userSettings.vocabsPerStage = $event))
            }, null, 512), [
              [_vModelText, _ctx.userSettings.vocabsPerStage]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t("messages.save settings")), 1)
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("messages.Change Password")), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.passwords.old = $event)),
          name: "passwordOld",
          type: "password",
          placeholder: _ctx.$t('messages.old password'),
          class: "form-control"
        }, null, 8, _hoisted_25), [
          [_vModelText, _ctx.passwords.old],
          [_directive_focus]
        ]),
        _hoisted_26,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.passwords.new1 = $event)),
          name: "passwordNew1",
          type: "password",
          placeholder: _ctx.$t('messages.New Password'),
          class: "form-control"
        }, null, 8, _hoisted_27), [
          [_vModelText, _ctx.passwords.new1]
        ]),
        _hoisted_28,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.passwords.new2 = $event)),
          name: "passwordNew2",
          type: "password",
          placeholder: _ctx.$t('messages.Repeat new password'),
          class: "form-control"
        }, null, 8, _hoisted_29), [
          [_vModelText, _ctx.passwords.new2]
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", _hoisted_31, _toDisplayString(_ctx.$t("messages.Change Password")), 1)
      ])
    ], 32)
  ]))
}